import view from "../../views/anticheat.js";
import KTAPI from "../api/index.api.js";
import { KTLang } from "../lang/lang";
let ac = {
    render: () => {
        return view;
    },
    after_render: async () => {
        KTLang.update();
        //const akbans = await KTAPI.getAkrosBans();
        //const akplayers = await KTAPI.getAkrosPlayers();

        //$(".akros-players-banned").text(akbans.banCount);
        //$(".akros-players-using").text(akplayers.playerCount);
        $(".akros-players-banned").removeClass("counted");
        $(".akros-players-using").removeClass("counted");

        //$(".akros-players-banned").attr("data-kt-countup-value", akbans.banCount);
        //$(".akros-players-using").attr("data-kt-countup-value", akplayers.playerCount);

        renderCompatible();

        KTApp.initCountUp();
        KTApp.initCountUpTabs();
    },
    root: false, 
    rerender: true,
    where: '#kt_content'
};

function renderCompatible() {   

    const os = getOSDetails();

    //console.log(os);
    let html = "";

    if(os.os == "Windows" && os.bits == "64-bit" && os.version !== "2000" && os.version !== "XP" && os.version !== "Vista" && os.version !== "7" && os.version !== "8" && os.version !== "8.1") {
        html = `<div class="alert border bg-light-success border-success d-flex align-items-center p-5 mb-5 bg-light-success" role="alert">
        <i class="fas fa-check-circle fs-1 text-success me-4"><span class="path1"></span><span class="path2"></span></i>
                
            <div class="d-flex flex-column">
                <span class="alert-text"><span data-i18n="akros.comp_a">Your operating system</span> <b>${os.os + ' ' + os.version + ' ' + os.bits}</b> <span data-i18n="akros.comp_b">is compatible with the anticheat</span></span>
            </div>
        </div>`;

    }
    else

    html = `<div class="alert border bg-light-primary border-primary d-flex align-items-center p-5 mb-5 bg-light-primary" role="alert">
        <i class="fas fa-exclamation-triangle fs-1 text-primary me-4"><span class="path1"></span><span class="path2"></span></i>
                
        <div class="d-flex flex-column">
            <span class="alert-text"><span data-i18n="akros.comp_a">Your operating system</span> <b>${os.os + ' ' + os.version + ' ' + os.bits}</b> <span data-i18n="akros.comp_c">is not compatible with the anticheat, please upgrade it to a compatible one</span></span>
        </div>
    </div>`;

    html = $(html);
    html.localize();
    $(".alert-compatible").html(html);
}


function getOSDetails() {
    const userAgent = navigator.userAgent;
    let os = null;
    let version = null;
    let bits = null;
  
    if (userAgent.indexOf('Win') !== -1) {
      os = 'Windows';
      if (userAgent.indexOf('Windows NT 10.0') !== -1) {
        version = '10';
      } else if (userAgent.indexOf('Windows NT 6.3') !== -1) {
        version = '8.1';
      } else if (userAgent.indexOf('Windows NT 6.2') !== -1) {
        version = '8';
      } else if (userAgent.indexOf('Windows NT 6.1') !== -1) {
        version = '7';
      } else if (userAgent.indexOf('Windows NT 6.0') !== -1) {
        version = 'Vista';
      } else if (userAgent.indexOf('Windows NT 5.1') !== -1) {
        version = 'XP';
      } else if (userAgent.indexOf('Windows NT 5.0') !== -1) {
        version = '2000';
      }
  
      if (userAgent.indexOf('WOW64') !== -1 || userAgent.indexOf('Win64') !== -1) {
        bits = '64-bit';
      } else {
        bits = '32-bit';
      }
    } else if (userAgent.indexOf('Mac') !== -1) {
      os = 'Mac OS X';
      if (userAgent.indexOf('Mac OS X 10_15') !== -1) {
        version = 'Catalina';
      } else if (userAgent.indexOf('Mac OS X 10_14') !== -1) {
        version = 'Mojave';
      } else if (userAgent.indexOf('Mac OS X 10_13') !== -1) {
        version = 'High Sierra';
      } else if (userAgent.indexOf('Mac OS X 10_12') !== -1) {
        version = 'Sierra';
      } else if (userAgent.indexOf('Mac OS X 10_11') !== -1) {
        version = 'El Capitan';
      } else if (userAgent.indexOf('Mac OS X 10_10') !== -1) {
        version = 'Yosemite';
      } else if (userAgent.indexOf('Mac OS X 10_9') !== -1) {
        version = 'Mavericks';
      } else if (userAgent.indexOf('Mac OS X 10_8') !== -1) {
        version = 'Mountain Lion';
      } else if (userAgent.indexOf('Mac OS X 10_7') !== -1) {
        version = 'Lion';
      } else if (userAgent.indexOf('Mac OS X 10_6') !== -1) {
        version = 'Snow Leopard';
      } else if (userAgent.indexOf('Mac OS X 10_5') !== -1) {
        version = 'Leopard';
      } else if (userAgent.indexOf('Mac OS X 10_4') !== -1) {
        version = 'Tiger';
      } else if (userAgent.indexOf('Mac OS X 10_3') !== -1) {
        version = 'Panther';
      } else if (userAgent.indexOf('Mac OS X 10_2') !== -1) {
        version = 'Jaguar';
      } else if (userAgent.indexOf('Mac OS X 10_1') !== -1) {
        version = 'Puma';
      } else if (userAgent.indexOf('Mac OS X 10_0') !== -1) {
        version = 'Cheetah';
      }
  
      if (userAgent.indexOf('Intel') !== -1) {
        bits = '64-bit';
      } else {
        bits = '32-bit';
      }
    } else if (userAgent.indexOf('Linux') !== -1) {
      os = 'Linux';
      if (userAgent.indexOf('x86_64') !== -1) {
        bits = '64-bit';
      } else {
        bits = '32-bit';
      }
    } else if (userAgent.indexOf('Android') !== -1) {
      os = 'Android';
      if (userAgent.indexOf('Android') !== -1) {
        if (userAgent.indexOf('arm64-v8a') !== -1 || userAgent.indexOf('aarch64') !== -1) {
          bits = '64-bit';
        } else {
          bits = '32-bit';
        }
      }
    } else if (userAgent.indexOf('iOS') !== -1) {
      os = 'iOS';
      if (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) {
        if (userAgent.indexOf('iPhone OS 11') !== -1 || userAgent.indexOf('iPhone OS 12') !== -1 || userAgent.indexOf('iPhone OS 13') !== -1 || userAgent.indexOf('iPhone OS 14') !== -1) {
          bits = '64-bit';
        } else {
          bits = '32-bit';
        }
      }
    }
  
    return {
      os,
      version,
      bits
    };
  }

export default ac;